module.exports = __webpack_public_path__ + "static/media/CompanyIcon.0964d254.svg";